module.exports = __webpack_public_path__ + "static/media/old reitway-global-property.ec0956c9.csv";